<div class="p-4 pb-3">
	<h6 class="fs-5 mb-0">Call Recordings</h6>
	<small>
		Recording Calls in System:
		<b>
			{{ this.recordingParams.totalRecords }}
		</b>
	</small>
</div>
<div class="d-flex justify-content-start px-4 pb-4">
	<input [ngClass]="{ loading: isLoading}"
		[(ngModel)]="recordingParams.name"
		(keyup)="callRecordingsListDebounce({searchText: recordingParams.name})"
		(keyup.enter)="callRecordingsList({searchText: recordingParams.name})"
		type="search"
		placeholder="Search by Phone Number or Customer Name"
		class="search-text-input me-3"
		style="min-width: 394px">
	<ng-select [clearable]="false"
		[searchable]="false"
		(change)="callRecordingsList({ direction: $event, page: 0 })"
		class="me-3"
		style="min-width: 218px;"
		placeholder="All calls">
		<ng-option *ngFor="let callType of [{id: 'in', name: 'Inbound'}, {id:'out', name: 'Outbound'}]"
			[value]="callType.id">
			{{ callType.name | capitalize }}
		</ng-option>
	</ng-select>
	<ng-select [clearable]="false"
		[searchable]="false"
		(change)="callRecordingsList({accountType: $event})"
		class="me-3"
		style="min-width: 218px;"
		placeholder="Customer Type">
		<ng-option *ngFor="let accType of UserAccountTypeEnum"
			[value]="accType">
			{{ accType | capitalize }}
		</ng-option>
	</ng-select>
	<div class="form-group date-fld me-3">
		<input #drp="bsDatepicker"
			[bsConfig]="bsConfig"
			(bsValueChange)="callRecordingsList({date: $event.toString()})"
			type="text"
			class="form-control"
			placeholder="dd/mm/yyyy"
			bsDatepicker>
		<button type="submit">
			<svg-icon (click)="drp.toggle()"
				src="assets/images/inputs/date_input_calendar.svg"></svg-icon>
		</button>
	</div>
	<app-switcher *ngIf="!!user.permissions.adminDashboard.allCallLogs"
		[switchList]="logSwitchItems"
		(switched)="callRecordingsList({phoneNr: $event.id === 1 ? this.currentPhone : null})"
		theme="grey"></app-switcher>
</div>
<div class="w-100 d-flex justify-content-center pb-4">
	<app-inline-spinner [spinnerConfig]="{ ldsLoader: true, showSpinner: isLoading }"></app-inline-spinner>
	<div *ngIf="!callRecordings.length && !isLoading"
		class="no-results">
		<p>No records found</p>
	</div>
</div>
<div class="w-100 flex-grow-1 overflow-auto">
	<table *ngIf="callRecordings.length && !isLoading"
		class="table table-borderless table-hover align-middle">
		<thead class="thead-white">
			<tr>
				<th class="fs-sm fw-normal text-nowrap ps-4"
					title="Inbound or outbound call">
					IN/OUT
				</th>
				<th [ngClass]="{
					asc: recordingParams.ascOrDesc === 'ASC' && recordingParams.sort === 'twilio_calls.duration',
					desc: recordingParams.ascOrDesc === 'DESC' && recordingParams.sort === 'twilio_calls.duration'
				}"
					(click)="callRecordingsList({ sort: 'twilio_calls.duration', ascOrDesc: recordingParams.ascOrDesc === 'ASC' ? 'DESC' : 'ASC'})"
					class="fs-sm fw-normal text-nowrap sortable">
					DURATION
				</th>
				<th class="fs-sm fw-normal text-nowrap">FROM</th>
				<th class="fs-sm fw-normal text-nowrap">TO</th>
				<th *ngIf="!recordingSource" class="fs-sm fw-normal text-nowrap">NOTES</th>
				<th class="fs-sm fw-normal text-nowrap">CUTOMER</th>
				<th class="fs-sm fw-normal text-nowrap">CUSTOMER TYPE</th>
				<th [ngClass]="{
					asc: recordingParams.ascOrDesc === 'ASC' && recordingParams.sort === 'twilio_calls.createdAt',
					desc: recordingParams.ascOrDesc === 'DESC' && recordingParams.sort === 'twilio_calls.createdAt'
				}"
					(click)="callRecordingsList({ sort: 'twilio_calls.createdAt', ascOrDesc: recordingParams.ascOrDesc === 'ASC' ? 'DESC' : 'ASC'})"
					class="fs-sm fw-normal text-nowrap sortable">
					DATE
				</th>
				<th class="fs-sm fw-normal text-nowrap"></th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let callRecord of callRecordings"
				class="call-log-row {{callRecord.status}}">
				<td class="fs-sm fw-normal text-nowrap ps-4"
					title="Direction/Duration">
					<svg-icon [src]="callRecord.direction == 'out' ? 'assets/images/call/outbound-call-icon.svg' : 'assets/images/call/inbound-call-icon.svg'"></svg-icon>
				</td>
				<td class="fs-sm fw-normal text-nowrap">
					{{ callRecord.duration | duration }}
				</td>
				<td class="fs-sm fw-normal text-nowrap">
					{{ callRecord.callFrom | replace: ' ' : '' | match:'(\\+\\d+)':"gi" | head | formatPhone }}
				</td>
				<td class="fs-sm fw-normal text-nowrap">
					{{ callRecord.callTo | replace: ' ' : '' | match:'(\\+\\d+)':"gi" | head | formatPhone }}
				</td>
				<td *ngIf="!recordingSource" class="fs-sm fw-normal">
					<div class="d-flex">
						<div *ngIf="callRecord.notesCount > 0" class="badge badge--floating bg-success px-1">{{ callRecord.notesCount }}</div>
						{{ +callRecord.notesCount === 0 ? '-' : '' }}
					</div>
				</td>
				<td *ngIf="callRecord.firstname || callRecord.surname"
					class="fs-sm fw-normal text-nowrap">
					{{ callRecord.firstname }} {{ callRecord.surname }}
				</td>
				<td *ngIf="!callRecord.firstname && !callRecord.surname"
					class="fs-sm fw-normal text-nowrap">
					Unknown
				</td>
				<td class="fs-sm fw-normal text-nowrap">
					{{ (callRecord.accountType ?? "Unknown") | capitalize }}
				</td>
				<td class="fs-sm fw-normal text-nowrap">
					{{ callRecord.createdAt | date: 'dd MMM yyyy HH:mm' }}
				</td>
				<td class="d-flex">
					<svg-icon (click)="makeACallLog(callRecord)"
						class="hover"
						src="assets/images/call/phone-handset.svg"></svg-icon>
					<div *ngIf="callRecord.mediaFile"
						class="playback">
						<svg-icon *ngIf="playing != callRecord.sId"
							(click)="initPlaybackRecord(callRecord)"
							class="hover"
							src="assets/images/call/play-icon.svg"
							@fadeIn
							@fadeOut></svg-icon>
						<svg-icon *ngIf="playing == callRecord.sId"
							(click)="stopPlayback(callRecord)"
							class="hover"
							src="assets/images/call/stop-icon.svg"
							@fadeIn
							@fadeOut></svg-icon>
					</div>
					<div appDropdown
						class="dropdown ys-dropdown-menu">
						<span class="hover"
							role="button"
							data-bs-toggle="dropdown"
							aria-expanded="false">
							<svg-icon src="assets/images/call/icon-menu-action.svg"></svg-icon>
						</span>
						<div class="dropdown-menu dropdown-menu-end shadow-sm p-0 g-0" style="right: 0;">
							<span class="dropdown-item text-primary py-2" *ngIf="!recordingSource" [ngClass]="{ 'disabled': +callRecord.notesCount === 0 }" (click)="showNotesFor(callRecord)"> Show notes </span>
							<span class="dropdown-item text-primary py-2 disabled">Copy data</span>
							<span class="dropdown-item text-primary py-2 disabled">Another menu</span>
						</div>
					</div>
				</td>
			</tr>
		</tbody>
	</table>
</div>
<div class="w-100 p-4">
	<app-pagination [params]="recordingParams" (update)="callRecordingsList()"></app-pagination>
</div>


<ng-template #notesTmpl>
	<div class="text-center"><app-inline-spinner [spinnerConfig]="{ ldsLoader: true, showSpinner: callNotes === null }"></app-inline-spinner></div>
	<div id="call-notes-cont" *ngIf="callNotes !== null">
		<div *ngFor="let note of callNotes" class="pb-1">
			<label class="fs-xs mb-1">
				{{ note.createdBy.contact?.firstname }} {{ note.createdBy.contact?.surname }} ({{
				note.createdAt | date : 'dd MMM yyyy @ HH:mm'
				}})</label>
			<div class="fs-sm" [innerHtml]="note.content | safeHTML"></div>
			<ng-container *ngIf="note.files.length > 0">
				<label class="fs-xs pt-2">Files({{note.files.length}}):</label>
				<div>
					<ng-container *ngFor="let file of note.files; let i = index">
						<a *ngIf="toolsService.isFileAnImage(file)"  target="_blank" href="{{ env.apiPath + 'notes/file/' + file }}"><img src="{{ env.apiPath + 'notes/file/' + file }}" width="30"/></a>
						<a *ngIf="!toolsService.isFileAnImage(file)"  target="_blank" href="{{ env.apiPath + 'notes/file/' + file }}">{{ toolsService.getFileType(file) }}</a>&nbsp;
					</ng-container>

				</div>
			</ng-container>
		</div>
	</div>
</ng-template>
